import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { API_BASE_URL } from '../config/api-config';
import { OnboardingRefreshService } from '../services/onboarding-refresh.service';
import { UserProfileService } from '../services/user-profile.service';

export const onboardingRefreshInterceptor: HttpInterceptorFn = (request, next) => {
  const path = request.url.split('?')[0];
  const relevant = !['GET', 'HEAD', 'OPTIONS'].includes(request.method) && [
    '/organizations/current/details', '/period-closing/locks', '/localization-settings',
    '/organizations/current/integrations/lhdn-myinvois', '/accounts', '/conversion-balances'
  ].some(prefix => path === API_BASE_URL + prefix || path.startsWith(API_BASE_URL + prefix + '/'));
  if (!relevant) return next(request);
  const refresh = inject(OnboardingRefreshService);
  const profiles = inject(UserProfileService);
  const userId = profiles.profile?.publicId;
  const orgId = profiles.activeOrganization?.organizationPublicId;
  return next(request).pipe(tap(event => {
    if (event instanceof HttpResponse && userId === profiles.profile?.publicId
        && orgId === profiles.activeOrganization?.organizationPublicId) refresh.changes.next();
  }));
};
